import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from "@material-ui/core/Grid";
import arrowDown from "Assets/Svg/arrow-down.svg";
import logo from "Assets/Svg/sumhr-logo.svg";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class HeroSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      value: 0,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { value } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div className="hero-container">
              <div style={{ position: "absolute", top: 64 }}>
                <img src={logo}></img>
              </div>
              <h1
                style={{
                  color: "#fff",
                  fontSize: 64,
                  width: "50%",
                  marginTop: 0,
                  marginBottom: 0,
                }}
              >
                Join our team
              </h1>
              <div
                style={{
                  width: "50%",
                  display: "inline-flex",
                  justifyContent: "flex-end",
                }}
              >
                <p
                  style={{
                    color: "#fff",
                    fontSize: 24,
                    marginRight: 16,
                    fontWeight: "bold",
                  }}
                >
                  See open positions
                </p>
                <a href="#openposition">
                  <div
                    style={{
                      width: 72,
                      height: 72,
                      background: "#1e8ced",
                      borderRadius: 72,
                      position: "relative",
                    }}
                  >
                    <img src={arrowDown} className="vertical-center"></img>
                  </div>
                </a>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(HeroSection)));
